import PanelMembers from "../../Pages/PanelMembers";

const navigation = {
  header: "",
  links: [
    { text: "Panel Members", icon: <></>, route: "members", component: PanelMembers },
    
  ],
};
export default navigation;
